import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {CalendarMonthOutlined} from 'views/icons';
import {Translate} from 'views/module';

import CardPaper from './CardPaper';

const StartDateCard = (props) => {
  const {startDate} = props;

  return (
    <CardPaper>
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <CalendarMonthOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.StartDate.Title' />
        </Typography>
      </Stack>

      <Typography variant="body2" sx={{fontWeight: 700, color: 'text.secondary'}}>
        <Translate expression={`jobDetail.StartDate.Options.${startDate.startTime}.Label`} />
      </Typography>
    </CardPaper>
  );
};

StartDateCard.propTypes = {
  startDate: PropTypes.object.isRequired,
};

export default StartDateCard;
